const isVisible = (e) => {
    return !!( e.offsetWidth || e.offsetHeight || e.getClientRects().length );
}

export default isVisible;
